settings_module = settings_module or {}
settings_module.places = (sorting_href)->
    csfr_key = 'csrfmiddlewaretoken'
    csfr_val = $("input[name=#{csfr_key}]").val()

    if not Modernizr.touch
        $('.sort .ordering').html('<span class="icon-move icon-large"></span>')
        $('.sort').sortable(
            cursor: 'move'
            axis:   'y'
            update: (e, ui)->
                icon = ui.item.find('.icon-move')
                $tbody = $(this)
                $tbody.sortable("refresh", { revert: true })
                sorted = $tbody.sortable("toArray")
                sorted = _.map(sorted, (i)-> _.last(i.split('_')))
                data = {'order': sorted.join(',')}
                data[csfr_key] = csfr_val
                $tbody.sortable("disable") # dokud nedobehne ajax, nedovolim menit poradi
                icon.toggleClass("icon-move inline-spinner") # roztocim spinner
                $.ajax
                    type:   'POST'
                    url:    sorting_href
                    data:   data
                    success: (msg)->
                        onceAnimate(ui.item,"sort-success")
                    error: ()->
                        onceAnimate(ui.item,"sort-cancel")
                        $tbody.sortable( "cancel" )
                    complete: ()->
                        icon.toggleClass('icon-move inline-spinner') # at to dopadlo jakkoliv vratim ikonu zpatky
                        $tbody.sortable("enable") # a dovolim znovu radit zaznamy
        ).disableSelection()

    multiSubmitHandler('form')
